import type { DiscoverPromoSlide } from "@shared/discoverPromoSlide";
import trpc from "@/shared/utils/trpc";
import { handleTrpcError } from "@/shared/utils/trpc/handletrpcError.util";
import { usePortalQuery } from "@/state/hooks/usePortalQuery";
import { queryKeys } from "@/state/queryKeys";
import { useMemo } from "react";
import { DEFAULT_DISCOVER_PROMO_SLIDES } from "../DiscoverPage.constants";

function mergePromoSlides(apiSlides: DiscoverPromoSlide[]): DiscoverPromoSlide[] {
  const apiIds = new Set(apiSlides.map((s) => s.id));
  const constants = DEFAULT_DISCOVER_PROMO_SLIDES.filter((s) => !apiIds.has(s.id));
  return [...apiSlides, ...constants];
}

export function useDiscoverPromoSlides(enabled: boolean) {
  const query = usePortalQuery({
    queryKey: queryKeys.discover.promoSlides(),
    enabled,
    staleTime: 60_000,
    queryFn: async () => {
      try {
        const response = await trpc.discover.listPublicPromoSlides.query();
        return (response.slides ?? []) as DiscoverPromoSlide[];
      } catch (err) {
        handleTrpcError(err);
        return [] as DiscoverPromoSlide[];
      }
    },
  });

  const apiSlides = enabled ? (query.data ?? []) : [];
  const slides = useMemo(() => mergePromoSlides(apiSlides), [apiSlides]);

  return {
    slides,
    loading: enabled && query.isInitialLoading,
  };
}
